<template>
  <div class="min-h-dvh bg-[#13191d] text-white transition-colors duration-300">
    <!-- Header -->
    <header class="bg-black/30">
      <div class="mx-auto pl-6 pr-2">
        <div class="flex justify-between items-center h-10">
          <div class="flex items-center gap-1">
            <div>
              <h1 class="text-lg font-semibold text-white">Multiviewer</h1>
            </div>
          </div>

          <div class="flex items-center gap-1">
            <!-- <button
              v-if="isLocalhost"
              @click="showDebugInfo = !showDebugInfo"
              class="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium text-white bg-purple-600 border border-transparent rounded-xs hover:bg-purple-700 focus:outline-hidden focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-800 transition-colors"
              title="Toggle Debug Information"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3">
                <path d="M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z"/>
              </svg>
              {{ showDebugInfo ? 'Hide' : 'Show' }} Debug
            </button> -->
            
            <!-- <button
              @click="toggleTestMode"
              :class="[
                'inline-flex items-center gap-1 px-3 py-1 text-xs font-medium text-white border border-transparent rounded-xs focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 transition-colors',
                useTestPath ? 'bg-orange-600 hover:bg-orange-700 focus:ring-orange-500' : 'bg-gray-600 hover:bg-gray-700 focus:ring-gray-500'
              ]"
              :title="useTestPath ? 'Disable Test Path (mv/...)' : 'Enable Test Path (mv/...)'"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3">
                <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              {{ useTestPath ? 'Test Mode ON' : 'Test Mode OFF' }}
            </button> -->

            <button
              @click="addPlayer"
              class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-yellow-600 border border-transparent rounded-xs hover:bg-yellow-700 focus:outline-hidden focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 focus:ring-offset-gray-800 transition-colors"
              title="Add Player"
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3">
                <path
                  d="M12 2.25c.414 0 .75.336.75.75v8.25h8.25a.75.75 0 010 1.5h-8.25v8.25a.75.75 0 01-1.5 0v-8.25H3a.75.75 0 010-1.5h8.25V3a.75.75 0 01.75-.75z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Streaming Manager (Collapsible) -->
    <div v-if="showStreamingManager" class="streaming-manager-section">
      <StreamingOutputInputManager />
    </div>

    <!-- Available Sources Info (Debug) -->
    <div v-if="showDebugInfo && inputSources.length > 0" class="bg-black/20 p-4 mx-4 mt-4 rounded-xs">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-medium text-gray-300">Available Input Sources ({{ inputSources.length }})</h3>
        <div class="text-xs px-2 py-1 rounded-xs" :class="useTestPath ? 'bg-orange-600/20 text-orange-300' : 'bg-green-600/20 text-green-300'">
          Path Mode: {{ useTestPath ? 'mv/...' : 'webrtc/adm/...' }}
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        <div v-for="source in inputSources" :key="source.id" class="text-xs bg-gray-800/50 p-2 rounded-xs">
          <div class="font-medium text-white">{{ source.name }}</div>
          <div v-if="source.originalUrl !== source.url" class="text-gray-500 text-[10px] mb-1">
            Original: {{ source.originalUrl }}
          </div>
          <div class="text-gray-400 truncate">{{ source.url }}</div>
          <div class="text-gray-500">Status: {{ source.status || 'N/A' }}</div>
        </div>
      </div>
    </div>

    <!-- Players Grid -->
    <div class="p-4">
      <div :class="getGridClass()" class="gap-4">
        <div v-for="player in players" :key="player.id" class="aspect-video rounded-xs ">
          <MvPlayerWebRtc
            :key="`${player.id}-${inputSources.length}-${player.source}`"
            :show-close-button="players.length > 1"
            :initial-source="player.source"
            :initial-audio-state="player.audioState"
            :additional-sources="inputSources"
            @close="removePlayer(player.id)"
            @source-changed="updatePlayerSource(player.id, $event)"
            @audio-state-changed="updatePlayerAudioState(player.id, $event)"
          />
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="players.length === 0" class="text-center py-20">
        <div class="text-gray-400">
          <svg class="mx-auto h-12 w-12 mb-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
          </svg>
          <h3 class="text-lg font-medium mb-2 text-white">No players added</h3>
          <p class="text-sm text-gray-300">Click the + button to add your first video player</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from "vue";
import MvPlayerWebRtc from "@/components/MvPlayerWebRtc.vue";
import StreamingOutputInputManager from "@/components/StreamingManager/StreamingOutputInputManager.vue";

// Connection Configuration
const connectionConfig = ref({
  host: "monitor.elas.tech", // Hostname or IPv4/IPv6 (for IPv6 enclose in brackets)
  port: 8889, // MediaMTX HTTP port (default 8889)
  subPath: "webrtc/adm", // Static prefix segment (e.g. webrtc)
  streamIP: "239.61.33.1", // IPv4 of source (validated)
  streamPort: 61105, // Source port (1-65535)
  protocol: "https", // http or https
});

// Reactive data
const players = ref([]);
const showStreamingManager = ref(false);
const showDebugInfo = ref(false);
const inputSources = ref([]);
const useTestPath = ref(true);
let playerIdCounter = 0;

// Check if running on localhost
const isLocalhost = computed(() => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
});

// Helper function to build connection URL
const buildConnectionUrl = (streamIP = null, streamPort = null) => {
  const { protocol, host, port, subPath } = connectionConfig.value;
  const ip = streamIP || connectionConfig.value.streamIP;
  const portNum = streamPort || connectionConfig.value.streamPort;
  return `${protocol}://${host}:${port}/${subPath}/${ip}:${portNum}`;
};

// Local storage functions
const STORAGE_KEY = 'multiviewer-players-state';

const savePlayersToLocalStorage = () => {
  try {
    const playersState = {
      players: players.value.map(player => ({
        id: player.id,
        source: player.source,
        name: player.name,
        audioState: player.audioState || {
          selectedAudioPair: 1,
          volume: 50,
          leftChannelMuted: false,
          rightChannelMuted: false,
          isMuted: false
        }
      })),
      useTestPath: useTestPath.value,
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(playersState));
    console.log('💾 Saved players state to localStorage:', playersState);
    console.log('💾 Audio states being saved:', playersState.players.map(p => ({ id: p.id, audioState: p.audioState })));
  } catch (error) {
    console.warn('Failed to save players state to localStorage:', error);
  }
};

const restorePlayersFromLocalStorage = () => {
  try {
    const savedState = localStorage.getItem(STORAGE_KEY);
    if (!savedState) {
      console.log('No saved players state found in localStorage');
      return false;
    }

    const parsedState = JSON.parse(savedState);
    console.log('Restored players state from localStorage:', parsedState);

    // Restore test path setting
    if (typeof parsedState.useTestPath === 'boolean') {
      useTestPath.value = parsedState.useTestPath;
      console.log(`Restored useTestPath: ${useTestPath.value}`);
    }

    // Restore players
    if (Array.isArray(parsedState.players) && parsedState.players.length > 0) {
      // Update the counter to avoid ID conflicts
      const maxId = Math.max(...parsedState.players.map(p => p.id || 0));
      playerIdCounter = maxId;

      // Restore the players array
      players.value = parsedState.players.map(player => {
        const restoredPlayer = {
          id: player.id || ++playerIdCounter,
          source: player.source || "",
          name: player.name || `Player ${player.id || playerIdCounter}`,
          audioState: player.audioState || {
            selectedAudioPair: 1,
            volume: 50,
            leftChannelMuted: false,
            rightChannelMuted: false,
            isMuted: false
          }
        };
        console.log(`🔄 Restoring player ${restoredPlayer.id} with source: ${restoredPlayer.source}`);
        console.log(`🔊 Audio state for player ${restoredPlayer.id}:`, restoredPlayer.audioState);
        return restoredPlayer;
      });

      console.log(`✅ Restored ${players.value.length} players from localStorage`);
      return true;
    }

    return false;
  } catch (error) {
    console.warn('Failed to restore players state from localStorage:', error);
    return false;
  }
};

// Grid layout calculation
const getGridClass = () => {
  const count = players.value.length;
  if (count === 1) return "grid grid-cols-1";
  if (count === 2) return "grid grid-cols-2";
  if (count <= 4) return "grid grid-cols-2";
  if (count <= 6) return "grid grid-cols-3";
  if (count <= 9) return "grid grid-cols-3";
  return "grid grid-cols-4";
};

// Toggle test mode function
const toggleTestMode = () => {
  useTestPath.value = !useTestPath.value;
  console.log(`Test mode ${useTestPath.value ? 'enabled' : 'disabled'} - using ${useTestPath.value ? 'mv/...' : 'webrtc/adm/...'} path format`);
  // Note: prepareInputSources() and savePlayersToLocalStorage() are now handled by the watcher
};

// Player management functions
const addPlayer = () => {
  playerIdCounter++;
  const newPlayer = {
    id: playerIdCounter,
    source: "", // Empty source - user will select from dropdown
    name: `Player ${playerIdCounter}`,
    audioState: {
      selectedAudioPair: 1,
      volume: 50,
      leftChannelMuted: false,
      rightChannelMuted: false,
      isMuted: false
    }
  };

  players.value.push(newPlayer);
  console.log("Added player:", newPlayer);
};

const removePlayer = (playerId) => {
  const index = players.value.findIndex((p) => p.id === playerId);
  if (index > -1) {
    players.value.splice(index, 1);
    console.log("Removed player:", playerId);
  }
};

// Force update player sources after restoration
const forceUpdatePlayerSources = async () => {
  // Wait a short time for components to be ready
  await new Promise(resolve => setTimeout(resolve, 100));
  
  // Trigger reactivity by creating a new array reference
  players.value = [...players.value];
  console.log("Forced update of player sources");
};

// Update player source when changed in component
const updatePlayerSource = (playerId, newSource) => {
  const player = players.value.find(p => p.id === playerId);
  if (player) {
    player.source = newSource;
    console.log(`Updated player ${playerId} source to: ${newSource}`);
  }
};

// Update player audio state when changed in component
const updatePlayerAudioState = (playerId, audioState) => {
  const player = players.value.find(p => p.id === playerId);
  if (player) {
    player.audioState = { ...player.audioState, ...audioState };
    console.log(`Updated player ${playerId} audio state:`, player.audioState);
  }
};

// Get access to the Vue instance and store
const instance = getCurrentInstance();

// Convert UDP URL to new MV format (test path)
const convertUdpToMvFormat = (originalUrl) => {
  try {
    // Parse UDP URL (e.g., udp://239.61.13.1:10120)
    const url = new URL(originalUrl);
    
    if (url.protocol === 'udp:') {
      const ip = url.hostname;
      const port = url.port;
      
      // Extract last two octets from IP (e.g., 239.61.13.1 → 13.1)
      const ipParts = ip.split('.');
      if (ipParts.length === 4) {
        const lastTwoOctets = ipParts.slice(2).join('.');
        
        // Build new format: mv/{lastTwoOctets}/{port}/a1
        const mvUrl = `https://monitor.elas.tech/mv/${lastTwoOctets}/${port}/a1/whep`;
        console.log(`Converted to MV format: ${originalUrl} → ${mvUrl}`);
        return mvUrl;
      }
    }
    
    // If not UDP or invalid format, return original URL
    return originalUrl;
  } catch (error) {
    console.warn(`Failed to convert URL to MV format: ${originalUrl}`, error);
    return originalUrl;
  }
};

// Convert UDP URL to WebRTC WHEP format
const convertUdpToWebRtc = (originalUrl) => {
  try {
    // Check if URL is already in WebRTC format
    if (originalUrl.includes('webrtc') && originalUrl.includes('whep')) {
      return originalUrl;
    }

    // Parse UDP URL (e.g., udp://239.1.125.104:10104)
    const url = new URL(originalUrl);
    
    if (url.protocol === 'udp:') {
      const ip = url.hostname;
      const port = url.port;
      
      // Convert to WebRTC format
      const webrtcUrl = `https://monitor.elas.tech/webrtc/adm/${ip}/${port}/whep`;
      console.log(`Converted UDP URL: ${originalUrl} → ${webrtcUrl}`);
      return webrtcUrl;
    }
    
    // If not UDP, return original URL
    return originalUrl;
  } catch (error) {
    console.warn(`Failed to convert URL: ${originalUrl}`, error);
    return originalUrl;
  }
};

// Prepare input sources from store
const prepareInputSources = () => {
  const inputs = instance.proxy.$store.state.permissions.inputs;
  if (!inputs) {
    console.log("No inputs found in store");
    return;
  }

  console.log("Raw inputs from store:", inputs);

  // Filter inputs with non-null URL and prepare them as sources
  const validInputs = inputs.filter(input => input.url && input.url.trim() !== '');
  
  inputSources.value = validInputs.map(input => {
    const originalUrl = input.url;
    
    // Choose conversion method based on test mode
    const convertedUrl = useTestPath.value 
      ? convertUdpToMvFormat(originalUrl)
      : convertUdpToWebRtc(originalUrl);
    
    const pathType = useTestPath.value ? 'mv/...' : 'webrtc/adm/...';
    
    return {
      id: input.id,
      name: `${input.name || input.description || `Input ${input.id}`}`,
      url: convertedUrl,
      originalUrl: originalUrl, // Keep original for reference
      type: 'input',
      status: input.status,
      description: input.description,
      pathType: pathType
    };
  });

  console.log(`Prepared ${inputSources.value.length} input sources from ${inputs.length} total inputs using ${useTestPath.value ? 'MV' : 'WebRTC'} format:`, inputSources.value);
};

// Computed property for all available sources (for debugging/display)
const allAvailableSources = computed(() => {
  const pathType = useTestPath.value ? 'mv/...' : 'webrtc/adm/...';
  const defaultSources = [
    {
      id: 'default-1',
      name: `Test Stream (${pathType})`,
      url: useTestPath.value 
        ? "https://monitor.elas.tech/mv/33.1/61105/a1/whep"
        : "https://monitor.elas.tech/webrtc/adm/239.61.33.1/61105/whep",
      type: 'default',
      pathType: pathType
    }
  ];
  return [...defaultSources, ...inputSources.value];
});

// Watchers for automatic state saving
watch(players, () => {
  savePlayersToLocalStorage();
}, { deep: true });

watch(useTestPath, () => {
  // Re-prepare input sources with new path format
  prepareInputSources();
  // Save the new test path setting
  savePlayersToLocalStorage();
});

// Watch inputSources changes and force player update if needed
watch(inputSources, () => {
  // Trigger reactivity when input sources change
  if (players.value.length > 0) {
    console.log(`Input sources updated (${inputSources.value.length} sources), triggering player refresh`);
  }
}, { deep: true });

// Lifecycle hooks
onMounted(async () => {
  try {
    // Call listInputs when component is mounted
    await instance.proxy.$store.dispatch('permissions/listInputs');
    console.log("Successfully loaded inputs on mount");
    
    // Prepare the input sources list
    prepareInputSources();
    
    // Try to restore players from localStorage
    const restored = restorePlayersFromLocalStorage();
    
    // If no players were restored, add initial player
    if (!restored) {
      addPlayer();
      console.log("Added initial player on mount (no saved state found)");
    } else {
      console.log("Restored players from localStorage on mount");
      // Force update players to ensure sources are properly set
      await forceUpdatePlayerSources();
    }
  } catch (error) {
    console.error("Failed to load inputs:", error);
    
    // Try to restore players even if loading inputs fails
    const restored = restorePlayersFromLocalStorage();
    
    // If no players were restored, add initial player
    if (!restored) {
      addPlayer();
      console.log("Added initial player on mount (despite input loading error)");
    } else {
      // Force update players even on error
      await forceUpdatePlayerSources();
    }
  }
});
</script>

<style scoped>
/* Smooth transitions for interactive elements */
</style>

